export const TRACK = 'track';
export const IDENTIFY = 'identify';

export const PRODUCT_REGISTRATION_SUCCESS_EVENT = 'product_registration';
export const PAYMENT_SUBMIT_CLICKED_ANALYTICS = 'product_pre_registration';
export const USER_VERIFIED_OTP = 'User Verified OTP';

export const utmParameters = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term'
];
